<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelSeven"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="150px">
      <el-form-item label="模块" prop="module">
        <el-input disabled placeholder="请输入" v-model="form.module"></el-input>
      </el-form-item>
      <el-form-item label="环境" prop="env">
        <el-select style="width: 100%" v-model="form.env" placeholder="默认为当前阶段环境">
          <el-option v-for="(item, index) in envs" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Jenkins任务名称" prop="env">
        <el-input :placeholder="
          '默认为生产匹配<' +
          form.module +
          '>_.+_autotest任务名，线下匹配<' +
          form.module +
          '>_.+_autotest_<env>任务名'
        " v-model="form.jobname"></el-input>
      </el-form-item>
      <el-form-item label="企业微信ID" prop="person">
        <el-input placeholder="默认为当前测试人员企业微信ID" v-model="form.person"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="runLoading" type="warning" :disabled="nonStandard" @click="onSubmit('run')">提 交</el-button>
        <el-button :loading="skipLoading" type="warning" @click="onSubmit('skip')">跳 过</el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      :title="modelParam.describe + '日志'" v-if="autoTestDoneVisible" :visible.sync="autoTestDoneVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" v-html="webSocket.msg" class="tips-message websocket_style" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
  getDevOpsSpaceStageSelectmapApi,
} from "@/server/tops/devOps";
import { mapState, mapMutations } from "vuex";
import { Progress, WebSocket } from "@/components/index.js";
import { TableOne } from "../table/index";

import { formatDate } from "../util";
export default {
  components: { TableOne, Progress, WebSocket },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {
        case_content: [
          { required: true, message: "请输入用例测试结果", trigger: "blur" },
        ],
      },
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
      envs: [],
      autoTestDoneVisible: false,
    };
  },
  async mounted() {
    this.form.module = this.modelParam.module_name;
    await this.queryDevOpsSpaceStageSelectmapApi();
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      webSocket: (state) => state.devOps.WEBSOCKET
    }),
    nonStandard() { // 非标系统标识
      return this.modelParam.module_name.startsWith('非标-')
    }
  },
  updated() { this.scrollToBottom({ bind: this, refName: 'webSocket' }) },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      try {
        const ret = await getDevOpsSpaceStageSelectmapApi();
        this.envs = ret[this.modelParam.stage_name + "-env"];
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = { ...this.form, ...ret.data };
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
            pid = ""
          } = this.modelParam;
          const {
            env = "",
            module = "",
            jobname = "",
            person = "",
          } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            env,
            module,
            jobname,
            person,
          };
          this.runLoading = true;
          this.autoTestDoneVisible = true;
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({
            url: '/ws/devops',
            params: { pid, task_id, stage_id, username },
            title: this.modelParam.module_name.toUpperCase()
          })
          try {
            const cacheDate = new Date();
            const ret = await postDevopsSpaceStageActionApi(param);
            let info = ret?.data?.output?.autotest[0] || {};
            this.timeOutSetProgressBar(`检测${info.code === 0 ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${info.code === 0 ? "success" : "exception"}`)
          } catch (error) {
            this.$notify({
              message: error || "检测失败",
              type: "error",
            });
            this.autoTestDoneVisible = false;
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 跳过
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        this.$notify({
          message: ret.status === "success" ? "跳过成功" : "跳过失败",
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
        this.tableData = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 480px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}
</style>
<style lang="scss">
.devOps-modelSeven {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>